import React, { useState } from 'react';
import {Button, Form, Input, message, Radio} from "antd";
import { useParams, useNavigate } from 'react-router-dom';
import {useMutation} from "react-query";
import {CreateApp} from "../../../../../api/apps";

export const AppCreateController = (props) => {
    const params = useParams();
    const nav = useNavigate();
    const { profile } = props;  


    const CreateMutationMutation = useMutation(
        (data) => CreateApp(data.developer_id, data),
        {
            onSuccess: (data, vars) => {
                message.success(`Приложение создано успешно`);
                nav(`/console/${params.developer_id}/app/${data.id}/store`);
            },
            onError: (e) => {
                console.error(`[CreateMutationMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    )

     const currentDeveloper = profile?.list?.[0];

     const hasLinux = currentDeveloper?.app_type?.includes('linux');

     const [selectedType, setSelectedType] = useState('application');
 
 
    return (
        <div className={`dev__layout apps`}>
            <div className={`dev__layout--header`}>
                <div className="header__info">
                    <h1>Создание приложения</h1>
                    <p>Подготовка нового приложения к публикации</p>
                </div>
            </div>
            <div className="dev__layout--content">
                <Form 
                    layout={`vertical`}
                    onFinish={(data) => {
                        CreateMutationMutation.mutate({
                            ...data, 
                            type: selectedType,
                            developer_id: params.developer_id
                        });
                    }}
                    initialValues={{  type: 'application', is_paid: 'free'}}
                >
                    <Form.Item
                        label={`Название приложения`}
                        name={`title`}
                        extra={`Укажите заголовок для страницы вашего приложения в магазине `}
                        rules={[
                            {required: true, message: 'Введите название приложения'}
                        ]}
                    >
                        <Input placeholder={`Введите название приложения`}/>
                    </Form.Item>
                    <Form.Item
                        label={`Тип приложения`}
                        name={`type`}
                        rules={[
                            {required: true, message: 'Выберите тип приложения'}
                        ]}
                    >
                        <div>
                            <div style={{ marginBottom: 5, marginTop: 5 }}><strong>Android</strong></div>
                            <Radio.Group
                            
                            onChange={(e) => setSelectedType(e.target.value)}
                            value={selectedType}>
                                <Radio.Button value="application">Приложение</Radio.Button>
                                <Radio.Button value="game">Игра</Radio.Button>
                            </Radio.Group>
                        </div>
                        {hasLinux && 
                            <div>
                                <div style={{ marginBottom: 5, marginTop: 5 }}><strong>Linux</strong></div>
                                <Radio.Group
                            
                            onChange={(e) => setSelectedType(e.target.value)}
                            value={selectedType}>
                                    <Radio.Button value="linux">Приложение</Radio.Button>
                                </Radio.Group>
                            </div>
                        }
                    </Form.Item>

                    <Form.Item label={`Доступ к приложению`} name={`is_paid`} extra={`Внимание! Приложения с платным функционалом внести в магазин приложений пока невозможно. Такой функционал станет доступен в ближайшее время. Об этом мы дополнительно сообщим.`}>
                        <Radio.Group>
                            <Radio.Button disabled value="paid">Платное</Radio.Button>
                            <Radio.Button value="free">Бесплатное</Radio.Button>
                        </Radio.Group>
                    </Form.Item>
                    <div className={`create__app--actions`}>
                        <Button type={`primary`} htmlType={`submit`} loading={CreateMutationMutation.isLoading}>Продолжить</Button>
                    </div>
                </Form>
            </div>
        </div>
    );
}

export default AppCreateController;